import { Component, ViewEncapsulation, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomerService, StorageService } from '../../_services/index';
import { DataService, OptionsserviceService, LoansService, OperationsService } from '../../_services/index';

@Component({
  selector: 'app-applicationsoffers',
  templateUrl: './applicationsoffers.component.html',
  styleUrls: ['./applicationsoffers.component.css', './style.css', './boot-outline-btn.css']
})
export class ApplicationsoffersComponent implements OnInit {

  @Input() requestId;
  @Input('view_from') view_from = 'request';
  text = 'Timeline';
  currentUser: any;
  parentRouteId: any;
  sub: any;
  loan: any;
  creating_contract = false;
  has_workflow = false;
  showPicture = false;
  offers: any;
  lenders_summary:any;
  count:any;
  loading = false;
  lenders : any;
  constructor(private dataService: DataService,
    public route: ActivatedRoute,
    public storageService: StorageService,
    public optionsService: OptionsserviceService,
    public loansService: LoansService,
    public operationsService: OperationsService,
    public router: Router, ) {
    this.currentUser = this.storageService.read<any>('currentUser');
  }
  ngOnInit() {
    this.getSummary();
  }
  getSummary() {
    this.sub = this.route.params.subscribe(params => {
      this.parentRouteId = +params['id'] || this.requestId;
      this.getLoan(); 
    });
  }
  getLoan() {
    this.loading = true;
    //this.dataService.getLoanFromTheDashboard.emit();
    this.loansService.getLoanOffers(this.currentUser.token, this.parentRouteId)
      .subscribe(data => {
        this.loading = false;
        this.offers = data.lenders;
        this.lenders = data.lenders;
        this.lenders_summary = data.summary; 
        this.loan = data.loan;
        this.count = data.count;
         
      });
  }
  openModal(section) {
    this.dataService.onOpenApplicationsModal.emit({ section: section, request_id: this.parentRouteId });
  }
  doingDisbursement(event) {
    event.new_loan = this.loan;
    this.dataService.disbursingRequest.emit(event);
  }
  openOfferLetter(request_id) {
    this.router.navigate(['./applications/offerletter/' + request_id]);
  }
  confirmAcceptOffer(offer) { 
    this.dataService.onOpenLoanChildModal.emit({ 'location': 'confirm_accept_offer_market', data: offer });
  }
  confirmRejectOffer(offer) {
    
    this.dataService.onOpenLoanChildModal.emit({ 'location': 'confirm_reject_offer_market', data: offer });
  }


  // acceptOffer(RLID) {
  //   this.loading = true;
  //   this.currentUser = this.storageService.read<any>('currentUser');
  //   this.loansService.acceptOffer(this.currentUser.token, RLID)
  //     .subscribe(lenders => {
  //       this.loading = false;
  //       this.lenders = lenders.lenders;
  //       this.lenders_summary = lenders.summary;
  //       this.masterClosed = 0;
  //       this.slaveOpen = 0;
  //       if (lenders.status == false) {
  //         this.showError(lenders.message)
  //       }
  //     }, err => {
  //       this.loading = false;
  //     });
  // }



  // rejectOffer(RLID) {
  //   this.loading = true;
  //   this.currentUser = this.storageService.read<any>('currentUser');
  //   this.loansService.rejectOffer(this.currentUser.token, RLID)
  //     .subscribe(lenders => {
  //       this.loading = false;
  //       this.lenders = lenders.lenders;
  //       this.lenders_summary = lenders.summary;
  //       this.masterClosed = 0;
  //       this.slaveOpen = 0;
  //     });
  // }
}
